export default {
  'pages.layouts.userLayout.title': 'Skeleton Admin 管理系统',
  // 登录页
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '用户名或密码错误',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.captcha.placeholder': '验证码',
  'pages.login.captcha.required': '请输入验证码！',
  'pages.login.captcha.fetchError': '验证码获取失败，请重试',
  'pages.login.captcha.notLoaded': '验证码未加载，请刷新验证码',
  'pages.login.captcha.refresh': '点击刷新验证码',
  'pages.login.captcha.reload': '刷新',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.submit': '登录',
  // 邮箱验证码登录
  'pages.login.email.placeholder': '请输入邮箱地址',
  'pages.login.email.required': '请输入邮箱地址！',
  'pages.login.email.invalid': '请输入有效的邮箱地址！',
  'pages.login.emailCode.placeholder': '请输入验证码',
  'pages.login.emailCode.required': '请输入验证码！',
  'pages.login.emailCode.send': '发送验证码',
  'pages.login.emailCode.sent': '验证码已发送',
  'pages.login.emailCode.sendFailed': '发送验证码失败',
  'pages.login.autoRegister': '未注册邮箱自动创建账号',
  'pages.login.emailCaptcha.title': '请输入图片验证码',
  'pages.login.emailCaptcha.confirm': '确认发送',
  // 协议同意
  'pages.login.agreement.checkbox': '我已阅读并同意《服务条款》和《隐私政策》',
  'pages.login.agreement.termsOfService': '服务条款',
  'pages.login.agreement.privacyPolicy': '隐私政策',
  'pages.login.agreement.required': '请先同意协议',
  'pages.login.agreement.modal.title': '协议同意',
  'pages.login.agreement.modal.content': '您需要同意以下协议才能继续使用系统：',
  'pages.login.agreement.modal.submit': '同意并登录',
  // 协议页面
  'pages.agreement.title': '协议详情',
  'pages.agreement.effectiveDate': '生效日期',
  'pages.agreement.version': '版本',
  // 欢迎页
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '欢迎使用 Skeleton Admin 管理系统。',
  // 错误页
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.403.subTitle': '抱歉，您没有权限访问此页面。',
  'pages.403.buttonText': '返回首页',
  // 错误处理
  'pages.error.appLoadFailed': '应用加载失败，请刷新重试',
  'pages.error.appError': '应用发生错误，请联系管理员',
  'pages.error.networkError': '网络连接失败，请检查网络',
  'pages.error.unknownError': '发生未知错误',
  'pages.error.timeout.title': '加载超时',
  'pages.error.timeout.message': '应用加载时间过长，请检查网络连接后重试。',
  'pages.error.network.title': '网络错误',
  'pages.error.network.message': '无法连接到服务器，请检查网络连接后重试。',
  'pages.error.loadFailed.title': '加载失败',
  'pages.error.loadFailed.message': '加载应用时发生错误，请重试。',
  'pages.error.permission.title': '访问被拒绝',
  'pages.error.permission.message':
    '您没有权限访问此页面。如有疑问请联系管理员。',
  // 子应用错误
  'pages.subApp.error.title': '子应用加载失败',
  'pages.subApp.error.description': '子应用加载过程中发生错误，请稍后重试。',
  'pages.subApp.error.retry': '重试',
  'pages.subApp.error.backHome': '返回首页',
  'pages.subApp.error.runtimeError': '子应用运行时错误',
  'pages.subApp.error.runtimeDescription': '子应用运行过程中发生未捕获的错误。',
  // 会话
  'pages.session.expired': '会话已过期，请重新登录',
  'pages.session.loggingOut': '正在退出...',

  // 找回密码页
  'pages.forgotPassword.title': '找回密码',
  'pages.forgotPassword.subtitle': '重置您的密码',
  'pages.forgotPassword.phoneTab': '手机号找回',
  'pages.forgotPassword.emailTab': '邮箱找回',
  'pages.forgotPassword.phone.placeholder': '请输入手机号码',
  'pages.forgotPassword.phone.required': '请输入手机号码！',
  'pages.forgotPassword.email.placeholder': '请输入邮箱地址',
  'pages.forgotPassword.email.required': '请输入邮箱地址！',
  'pages.forgotPassword.email.invalid': '请输入有效的邮箱地址！',
  'pages.forgotPassword.verifyCode.placeholder': '请输入验证码',
  'pages.forgotPassword.verifyCode.required': '请输入验证码！',
  'pages.forgotPassword.password.placeholder': '请输入新密码',
  'pages.forgotPassword.password.required': '请输入新密码！',
  'pages.forgotPassword.confirmPassword.placeholder': '请确认新密码',
  'pages.forgotPassword.confirmPassword.required': '请确认新密码！',
  'pages.forgotPassword.password.mismatch': '两次输入的密码不一致',
  'pages.forgotPassword.password.min': '密码至少6位',
  'pages.forgotPassword.sendCode': '发送验证码',
  'pages.forgotPassword.submit': '重置密码',
  'pages.forgotPassword.success.title': '密码重置成功',
  'pages.forgotPassword.success.desc': '您的密码已重置，请使用新密码登录',
  'pages.forgotPassword.goLogin': '前往登录',
  'pages.forgotPassword.code.sent': '验证码已发送',
  'pages.forgotPassword.code.sendFailed': '发送验证码失败',
  'pages.forgotPassword.verifyId.missing': '请先获取验证码',
  'pages.forgotPassword.success': '密码重置成功！',
  'pages.forgotPassword.failed': '密码重置失败，请重试',
  'pages.forgotPassword.captcha.fetchError': '验证码获取失败，请重试',
  'pages.forgotPassword.captcha.required': '请输入验证码！',
  'pages.forgotPassword.captcha.notLoaded': '验证码未加载，请刷新验证码',
  'pages.forgotPassword.captcha.refresh': '点击刷新验证码',
  'pages.forgotPassword.captcha.reload': '刷新',
  'pages.forgotPassword.captcha.placeholder': '请输入验证码',
  'pages.forgotPassword.captchaModal.title': '请输入图片验证码',
  'pages.forgotPassword.captchaModal.submit': '确认发送',

  // CMS 模板
  'cms.template.status.0': '禁用',
  'cms.template.status.1': '启用',
  'cms.template.type.RWD': '响应式',
  'cms.template.type.PC': 'PC端',
  'cms.template.type.MOBILE': '移动端',
};
